module.exports = __webpack_public_path__ + "img/code_white.a18703b5.svg";